import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create(() => ({
  container: {
    marginTop: theme.spacing[2],
  },
}));
